<div
    class="vto-beauty-modal"
    data-nosnippet
    [class.keyboard-navigation]="layoutFacade.keyboardNavigation$ | async"
    cdkTrapFocus>
    <button
        id="vto-modal-close-button"
        i18n-aria-label="@@hermes.accessibility.close_tray"
        aria-label="Close"
        type="button"
        (click)="closeModal($event)"
        class="close-button">
    </button>

    <!-- User must approve -->
    @if (vtoBeautyFacade.vtoModalConfiguration$ | async; as vtoModalConfiguration) { @if
    (vtoModalConfiguration.isApproval === false) {

    <div class="approval-background" [style.background-image]="imgSrc"></div>
    <div class="approval-footer">
        <form [formGroup]="approvalFormGroup">
            <h-checkbox [labelledById]="'approval-block-text'" [insideLabel]="true" formControlName="checkApproval">
                <p id="approval-block-text" [innerHTML]="approvalText"></p>
            </h-checkbox>
        </form>
        <h-call-to-action
            class="launch-camera-button"
            [dataTestId]="'launch-camera-button'"
            [disabled]="!approvalFormControl.value"
            (click)="userApprove()"
            i18n="@@hermes.product-page.vto-use-camera">
            Use camera
        </h-call-to-action>
    </div>

    }
    <!-- END User must approve -->

    <!-- After user approve -->
    <div class="vto-module" [class.hidden]="vtoModalConfiguration.isApproval === false">
        @if (vtoModalConfiguration.modalStatus === 'ON_ERROR') {
        <div class="vto-module-error">
            <h-message-block
                class="vto-message-error"
                [showBackground]="false"
                [autoAddPadding]="false"
                [type]="'info'">
                @if (vtoModalConfiguration.sdkError === 'ERROR_RESOLUTION') {
                <ng-container i18n="@@hermes.product-page.vto-resolution-error-message">Error resolution</ng-container>
                } @if (vtoModalConfiguration.sdkError === 'ERROR_CAMERA') {
                <ng-container i18n="@@hermes.product-page.vto-no-camera-error-message">Error camera</ng-container>
                } @if (vtoModalConfiguration.sdkError === 'ERROR_TIMEOUT') {
                <ng-container i18n="@@hermes.product-page.vto-general-error-message">Error timeout</ng-container>
                }
            </h-message-block>
        </div>
        } @if (vtoModalConfiguration.modalStatus !== 'ON_ERROR') {
        <div class="vto-module-container">
            <h-virtual-try-on-camera></h-virtual-try-on-camera>
            <h-virtual-try-on-selector></h-virtual-try-on-selector>
        </div>
        }
    </div>

    }
    <!-- END After user approve -->
</div>
